<template>
  <div>



    <div class="oc-notifications-area">
      <div id="oc-notifications-heading">
        <span>Notifications</span>
        <span @click="this.handleCloseNotifications" class="oc-close-notifications">Close X</span>
      </div>
      <div class="oc-notifications-body">
      <ul>
        <li v-for="item in subscribedNotifications" :key="item.messageId">
          {{item.message}}
        </li>
      </ul>

      </div>

    </div>

  </div>
</template>

<script>

    export default {
        name: "NotificationsView",
        components:{

        },

        computed:{
          subscribedNotifications:{
            get(){
              return this.$store.getters.subscribedNotifications;
            }
          }

      },
      methods:{
        handleCloseNotifications(){
          this.$parent.handleCloseNotifications();


        },
      },
    }
</script>

<style scoped>
  .oc-notifications-area{
    background-color: whitesmoke;
    border-radius: 3px;
    border: 1px #007dc2 solid;
    margin:8px;
    padding:8px;
  }
  .oc-close-notifications{
    float:right;
    cursor:pointer;
    font-size: .8em;
  }
  #oc-notifications-heading {
    padding:10px 0px 16px;
    font-size: 1em;
    color:#007dc2;
  }
  .oc-close-notifications{
    float:right;
    cursor:pointer;
    font-size: .8em;
  }
  .oc-notifications-area li{
    list-style-type: circle;
    margin-bottom:1.2em;
  }
  .oc-notifications-body{
    color:white;


  }


</style>
